import styled from "styled-components";
import {MbjLoading, MbjWidgetClassic} from "@mbj-front-monorepo/ui";
import {useParams} from "react-router-dom";
import {
  components,
  useGetResultsSearchReclassementBySearch
} from "@mbj-front-monorepo/data-access";
import {useEffect, useMemo, useState} from "react";
import {ResultReclassementCard} from "./ResultReclassementCard";

interface ResultReclassementCtrlProps{
  className?:string;
  min:number;
  max:number;
  clickCompare:(result:components["schemas"]["ResultsSearchReclassement-resultssearchreclassement.read_searchs.read_read.Member_read.UserMetier_read.Metier_statutresult.read_read.MemberMetierReclassement_read.ReclassementEmployees_read.Employee.simple"])=>void;
}

const ResultReclassementCtrl = (props:ResultReclassementCtrlProps)=>{
  const {id} = useParams();
  const ResultsQuery = useGetResultsSearchReclassementBySearch(id ? parseInt(id) : 0)

  const listResult = useMemo(()=>{
    if(!ResultsQuery.data){
      return [];
    } else {
      return ResultsQuery.data.filter(r=>{
        const CondMin = r.score && r.score >= props.min;
        const CondMax = r.score && r.score <= props.max;
        return CondMax && CondMin;
      })
    }
  }, [ResultsQuery.data, props.min, props.max])
  return (
    <div className={"result_emp "+props.className}>
      <div className={"wrap_results"}>
        {ResultsQuery.isLoading ? (<MbjLoading/>) : ResultsQuery.isError ? 'Error data' :
          (
            <div className={"wrap_result"}>
              {listResult.map((item)=>(
                <ResultReclassementCard key={`r${item.id}`} Search={item} clickCompare={props.clickCompare}/>
              ))}
            </div>
          )
        }
      </div>
    </div>
  )
}

export const ResultReclassement = styled(ResultReclassementCtrl)`
  .wrap_result{
    display: flex;
    flex-wrap: wrap;
  }
`
